// TODO: Remove from `core-js@4`
require('../modules/es.aggregate-error');



// WEBPACK FOOTER //
// ../node_modules/core-js-pure/modules/esnext.aggregate-error.js